import React, { Fragment } from 'react';
import Swal from 'sweetalert2'
import { solicitudActions } from '../redux/solicitud/actions'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useState } from 'react';


export const Seguimiento = (props) => {

  const dispatch = useDispatch();

  const handleVerification = () => {
    Swal.fire({
      title: 'Introduzca su código de solicitud',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Buscar',
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      inputValidator: (solCod) => {
        if (!solCod) {
          return 'Debe ingresar el codigo de solicitud!'
        }
      },
      preConfirm: (solCod) => {
        let codFormated = solCod.toUpperCase()
        dispatch(solicitudActions.verifySolicitudStateRequest(codFormated));
      },
    })
  };

  return (
    <div id='seguimiento' className='text-center'>
      <div className='container'>
        <div className='section-title'>
          <h2>Seguimiento</h2>
        </div>
        {/* <div className='row'>
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.title}-${i}`} className='col-xs-12 col-md-4'>
                  {' '}
                  <i className={d.icon}></i>
                  <h3>{d.title}</h3>
                  <p><a href={d.link}>{d.text}</a></p>
                </div>
              ))
            : 'Loading...'}
        </div> */}
            {/* <div className='col-md-12'>
            <div className='contact-item'> */}
              <h3>¿Ya realizó su solicitud?</h3>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                <p className="text-decoration-underline fst-italic" onClick={handleVerification} style={{ cursor: 'pointer', fontSize: '25px',color: '#D36FDD', textDecoration: 'underline', paddingLeft: '5px', paddingBottom:'30px' }}>Haga click aqui para realizar seguimiento a su solicitud, descargar el comprobante y para descargar el formulario suscrito.</p>
              </div>
            </div>
          </div>
    //   </div>
    // </div>
  )
}
